// Technical drawings for part pages.
// Priority: part.drawing_url (per-part, from source crawl) > TYPE_DRAWINGS.
// TYPE_DRAWINGS: source-site master drawings verified identical for every model of the type.
const TYPE_DRAWINGS = {
  "segment-group": "/drawings/sprocket-segment-group-technical-drawing.webp",
  "sprocket-segment-type-1": "/drawings/sprocket-segment-technical-drawing.webp",
  "sprocket-segment-type-2": "/drawings/sprocket-segment-technical-drawing.webp",
  "track-nut": "/drawings/track-nut-technical-drawing.webp",
  "track-bolt": "/drawings/track-bolt-technical-drawing.webp",
  "bolt": "/drawings/track-bolt-technical-drawing.webp",
  "rubber-track": "/drawings/rubber-track-technical-drawing.webp",
};

// Legacy DB drawing_url paths -> SEO-named files (same images, descriptive filenames).
const DRAWING_SEO_NAMES = {
  "/drawings/src-chain1.webp": "/drawings/track-chain-technical-drawing-1.webp",
  "/drawings/src-chain2.webp": "/drawings/track-chain-technical-drawing-2.webp",
  "/drawings/src-chain3.webp": "/drawings/track-chain-technical-drawing-3.webp",
  "/drawings/src-chain4.webp": "/drawings/track-chain-technical-drawing-4.webp",
  "/drawings/src-croller1.webp": "/drawings/carrier-roller-technical-drawing-1.webp",
  "/drawings/src-croller2.webp": "/drawings/carrier-roller-technical-drawing-2.webp",
  "/drawings/src-croller3.webp": "/drawings/carrier-roller-technical-drawing-3.webp",
  "/drawings/src-croller4.webp": "/drawings/carrier-roller-technical-drawing-4.webp",
  "/drawings/src-idler1.webp": "/drawings/track-idler-technical-drawing-1.webp",
  "/drawings/src-idler2.webp": "/drawings/track-idler-technical-drawing-2.webp",
  "/drawings/src-idler3.webp": "/drawings/track-idler-technical-drawing-3.webp",
  "/drawings/src-idler4.webp": "/drawings/track-idler-technical-drawing-4.webp",
  "/drawings/src-idler5.webp": "/drawings/track-idler-technical-drawing-5.webp",
  "/drawings/src-idler6.webp": "/drawings/track-idler-technical-drawing-6.webp",
  "/drawings/src-idler7.webp": "/drawings/track-idler-technical-drawing-7.webp",
  "/drawings/src-roller1.webp": "/drawings/track-roller-technical-drawing-1.webp",
  "/drawings/src-roller2.webp": "/drawings/track-roller-technical-drawing-2.webp",
  "/drawings/src-roller3.webp": "/drawings/track-roller-technical-drawing-3.webp",
  "/drawings/src-roller4.webp": "/drawings/track-roller-technical-drawing-4.webp",
  "/drawings/src-roller5.webp": "/drawings/track-roller-technical-drawing-5.webp",
  "/drawings/src-roller6.webp": "/drawings/track-roller-technical-drawing-6.webp",
  "/drawings/src-roller7.webp": "/drawings/track-roller-technical-drawing-7.webp",
  "/drawings/src-roller8.webp": "/drawings/track-roller-technical-drawing-8.webp",
  "/drawings/src-rubber-track.webp": "/drawings/rubber-track-technical-drawing.webp",
  "/drawings/src-segment-group.webp": "/drawings/sprocket-segment-group-technical-drawing.webp",
  "/drawings/src-shoe1.webp": "/drawings/track-shoe-technical-drawing-1.webp",
  "/drawings/src-shoe2.webp": "/drawings/track-shoe-technical-drawing-2.webp",
  "/drawings/src-shoe3.webp": "/drawings/track-shoe-technical-drawing-3.webp",
  "/drawings/src-sprocket-segment.webp": "/drawings/sprocket-segment-technical-drawing.webp",
  "/drawings/src-track-bolt.webp": "/drawings/track-bolt-technical-drawing.webp",
  "/drawings/src-track-nut.webp": "/drawings/track-nut-technical-drawing.webp",
};

export const drawingSrc = (url) => (url ? DRAWING_SEO_NAMES[url] || url : url);

// Category|type combos where the Details/Technical-Drawing section is hidden entirely.
const HIDE_DETAILS = new Set([]);

export const categoryDrawing = (machineryType, typeKey) =>
  TYPE_DRAWINGS[typeKey] || null;

export const hideDetailsSection = (machineryType, typeKey) =>
  HIDE_DETAILS.has(`${machineryType}|${typeKey}`);
